import Vue from "vue";

import {BootstrapVue, IconsPlugin} from "bootstrap-vue";


Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
